import React from 'react';
import { ClockIcon, TvIcon, BrainIcon, HeartIcon, WalletIcon, HomeIcon } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: ClockIcon,
    title: 'Listo en 5 minutos',
    desc: 'Abrís, imprimís y jugás.'
  }, {
    icon: TvIcon,
    title: 'Menos pantallas',
    desc: 'Una alternativa real para el día a día.'
  }, {
    icon: BrainIcon,
    title: 'Estimula el desarrollo',
    desc: 'Lenguaje, motricidad y atención.'
  }, {
    icon: HeartIcon,
    title: 'Tiempo de calidad',
    desc: 'Momentos en familia sin estrés.'
  }, {
    icon: WalletIcon,
    title: 'Ahorrás dinero',
    desc: 'Reutilizable cuantas veces quieras.'
  }, {
    icon: HomeIcon,
    title: 'Desde casa',
    desc: 'Sin materiales costosos ni salidas.'
  }];
  return <section className="bg-white px-5 py-10 sm:py-12" data-id="element-17">
      <div className="max-w-3xl mx-auto" data-id="element-18">
        <div className="text-center mb-8" data-id="element-19">
          <p className="text-xs uppercase tracking-wider text-brand-green-600 font-bold mb-3" data-id="element-20">
            Beneficios
          </p>
          <h2 className="font-extrabold text-3xl sm:text-4xl text-brand-ink leading-tight tracking-tight" data-id="element-21">
            Lo que vas a lograr
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4" data-id="element-22">
          {benefits.map(({
          icon: Icon,
          title,
          desc
        }) => <div key={title} className="flex items-start gap-4 bg-brand-green-50/40 rounded-2xl p-5 border border-brand-green-100/60" data-id="element-23">
              <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center shrink-0 shadow-soft" data-id="element-24">
                <Icon className="w-5 h-5 text-brand-green-600" data-id="element-25" />
              </div>
              <div data-id="element-26">
                <h3 className="font-bold text-brand-ink leading-tight" data-id="element-27">
                  {title}
                </h3>
                <p className="text-sm text-slate-600 mt-0.5" data-id="element-28">{desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}